import { capitalize } from '@/core/helpers';
import type { IUser } from '@/types/user';
import { isEmptyString } from '@/src/shared/utils/string';

export const getPlatformName = (platform: string): string => {
  if (isEmptyString(platform)) {
    return '';
  }
  const lowerCasePlatformName = platform.toLowerCase();
  switch (lowerCasePlatformName) {
    case 'linkedin':
      return 'LinkedIn';
    case 'tiktok':
      return 'TikTok';
    case 'facebook':
      return 'Facebook';
    case 'facebook_2':
      return 'Facebook Business 2';
    case 'facebook-profile':
      return 'Facebook Personal';
    case 'youtube':
      return 'YouTube';
    case 'instagram_business':
      return 'Instagram Business';
    case 'instagram':
      return 'Instagram';
    case 'twitter':
      return 'X (Twitter)';
    case 'google_my_business':
      return 'Google My Business';
    default:
      return capitalize(lowerCasePlatformName);
  }
};

export function isPlatformConnected(
  socialId: string,
  accounts: IUser['user_accounts']
) {
  return accounts[socialId].enabled;
}

export function isPlatformNeedsReConnect(
  socialId: string,
  accounts: IUser['user_accounts']
) {
  return accounts[socialId].enabled && accounts[socialId].token_expired;
}

export function getInstagramConnectionStatus(user: IUser) {
  let connected = false;
  let needToReconnect = false;

  // Instagram account status
  const isIgEnabled = user.user_accounts?.['instagram']?.enabled;
  const isIgExpired = user.user_accounts?.['instagram']?.token_expired;

  // Instagram Business account status
  const isIgBusinessEnabled =
    user.user_accounts?.['instagram_business']?.enabled;
  const isIgBusinessExpired =
    user.user_accounts?.['instagram_business']?.token_expired;

  // Check if either Instagram or Instagram Business is connected and valid (token not expired)
  const isInstagramConnected = isIgEnabled && !isIgExpired;
  const isInstagramBusinessConnected =
    isIgBusinessEnabled && !isIgBusinessExpired;

  connected = isInstagramConnected || isInstagramBusinessConnected;

  // Check if either Instagram or Instagram Business needs to reconnect (token expired)
  const isInstagramNeedReconnect = isIgEnabled && isIgExpired;
  const isInstagramBusinessNeedReconnect =
    isIgBusinessEnabled && isIgBusinessExpired;

  needToReconnect =
    !connected &&
    (isInstagramNeedReconnect || isInstagramBusinessNeedReconnect);

  return { connected, needToReconnect };
}
